const loadScript = (src) => { 
    const script = window.document.createElement("script");
    script.src = src;
    script.defer = true;
    script.type = "text/javascript";
    document.getElementsByTagName("head")[0].appendChild(script);
};

export default loadScript;
